import React from 'react';
import classnames from 'classnames';

import Footer from '../Footer';

import styles from './TermsOfUse.module.css';

const TermsOfUse = () => {
  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.container}>
          <h1 className={styles.headline}>Terms of Use</h1>
          <p className={classnames([styles.paragraph, styles.paragraph_lead])}>
            Terms of Use <br />
            Effective date: October 1, 2015
          </p>
          <h2 className={styles.subheadline}>Your Acceptance</h2>
          <p className={styles.paragraph}>
            Welcome to the Terms of Service for Sure, Inc.’s website and its
            mobile application ("app"). This is an agreement ("Agreement")
            between, Sure, Inc. ("Sure" "us," "our," or "we"), and you, a user
            of our website or app or another of our services. By clicking agree
            or by accessing our website or using any of Sure’s services, you
            agree to be bound by this Agreement and Sure’s Privacy Policy.
          </p>
          <p className={styles.paragraph}>
            PLEASE READ THE TERMS OF SERVICE CAREFULLY BEFORE USING THE APP OR
            THE WEBSITE. IF YOU DO NOT AGREE TO THESE TERMS, YOU MUST NOT USE
            SURE’S APP OR OUR WEBSITE.
          </p>
          <p className={styles.paragraph}>
            Users of our app and our website must be 18 or above. If you are
            under the age of 18 please stop using our Site and Service
            immediately.
          </p>
          <h2 className={styles.subheadline}>Description of Service</h2>
          <p className={styles.paragraph}>
            Sure offers users a simple way to purchase episodic insurance
            policies covering daily activities from one or more of our Insurance
            Partners. (our "Services.") We offer Services through a Sure mobile
            application (our "App") and our website ("Site.")
          </p>
          <h2 className={styles.subheadline}>Sure Accounts</h2>
          <p className={styles.paragraph}>
            To use our services, you are required to create a unique profile
            called a "Sure Account". Account registration requires you to submit
            certain personal information, as is further described in and
            governed by our Privacy Policy. You agree to submit accurate,
            up-to-date, complete, and truthful information when creating a Sure
            Account. We have the final discretion in granting accounts and
            reserve the right to reject users without explanation. You are
            responsible for all activity that occurs under your account, and you
            agree to maintain the security and secrecy of the username and
            password assigned to your Sure Account. You may only possess one
            Sure Account.
          </p>
          <p className={styles.paragraph}>
            When creating a Sure Account, you will be asked to designate a
            preferred payment method. Sure does not collect or retain payment
            card information.
          </p>
          <h2 className={styles.subheadline}>End User License Agreement</h2>
          <p className={styles.paragraph}>
            The use of the Sure Mobile Application (the "App") is governed by
            the following end user license agreement. By downloading and using
            the mobile app, you acknowledge that this end user license agreement
            is between you and Sure, not Apple, and that Sure, not Apple, is
            solely responsible for the App.
          </p>
          <p className={styles.paragraph}>
            <strong>Scope of License</strong>: Subject to these Terms of
            Service, Sure grants you a non-transferrable, non-exclusive license
            to use the Sure App for your personal use. Also subject to these
            Terms of Use, Sure grants you a non-transferrable, non-exclusive
            license to use a copy of the App downloaded solely in connection
            with the other Sure Services to your iPhone, iPad, or iPod Touch.
          </p>
          <p className={styles.paragraph}>
            <strong>Certain Restrictions</strong>: The rights granted to you by
            these Terms of Service are subject to the following restrictions:
            (a) you shall not license, sell, rent, lease, transfer, assign,
            distribute, host, or otherwise commercially exploit any Sure Service
            or the App; (b) you shall not modify, translate, adapt, merge, make
            derivative works of, disassemble, decompile, reverse compile or
            reverse engineer any part of the Sure Services or the App, except to
            the extent the foregoing restrictions are expressly prohibited by
            applicable law; (c) you shall not access the Sure Services or the
            App in order to build a similar or competitive service or
            application; (d) except as expressly stated herein, no part of the
            Sure Services or the App may be copied, reproduced, distributed,
            republished, downloaded, displayed, posted or transmitted in any
            form or by any means, or (e) you shall not remove or destroy any
            copyright notices or other proprietary markings contained on or in
            any App. Any future release, update, or other addition to
            functionality of the Sure Services or the App shall be subject to
            these Terms of Use, unless otherwise provided in terms associated
            with such addition.
          </p>
          <p className={styles.paragraph}>
            <strong>Modification</strong>: Sure reserves the right, at any time,
            to modify, suspend, or discontinue the Sure Services or the App or
            any part thereof with or without notice. In the future we may offer
            additional services, features, functionalities and in-app purchases.
            You agree that Sure will not be liable to you or to any third party
            for any modification, suspension, or discontinuance of the Sure
            Services or the App or any part thereof.
          </p>
          <p className={styles.paragraph}>
            <strong>Ownership</strong>: The App provided to you is licensed to
            you and not sold. Sure (and its licensors, where applicable) own all
            right, title and interest, including all related intellectual
            property rights, in and to the Sure Services and the App. These
            Terms of Service are not a sale and they do not convey to you any
            rights of ownership in or related to the App. The Sure name, logo,
            and the product names associated with the Sure Service belong to
            Sure, Inc. (or its licensors, where applicable), and no right or
            license is granted to use them by implication, estoppel or
            otherwise. Sure (and its licensors, where applicable) reserve all
            rights not granted in this Agreement.
          </p>
          <h2 className={styles.subheadline}>
            Third Party Services and Content
          </h2>
          <p className={styles.paragraph}>
            Sure’s Services may be made available or accessed in connection with
            third party services and content (including advertising) that Sure
            does not control. You acknowledge that different terms of use or
            service, and different privacy policies may apply to your use of
            such third party services and content.
          </p>
          <h2 className={styles.subheadline}>Use of SURE</h2>
          <p className={styles.paragraph}>
            When using Sure, you are responsible for your use of the app or
            website, and for any use of Sure made using your account. You agree
            not to access, copy, or otherwise use Sure, including our
            intellectual property and trademarks, except as authorized by these
            Terms of Service or as otherwise authorized in writing by Sure. You
            agree not to use Sure to:
          </p>
          <ul className={styles.list}>
            <li>
              You will not copy, distribute or disclose any part of the App,
              Site or the Service in any medium, including without limitation by
              any automated or non-automated "scraping";
            </li>
            <li>
              You will not submit fraudulent insurance applications, insurance
              claims, or otherwise attempt to defraud Sure, its Insurance
              Partners, or any other party in connection with your use of the
              App, Site, or the Service;
            </li>
            <li>
              You will not use any automated system, including without
              limitation "robots," "spiders," "offline readers," etc., to access
              the App, Site or the Service in a manner that sends more request
              messages to Sure servers than a human can reasonably produce in
              the same period of time by using a conventional on-line web
              browser (except that Sure grants the operators of public search
              engines revocable permission to use spiders to copy materials from
              the publicly available searchable indices of the materials, not
              caches or archives of such materials);
            </li>
            <li>
              You will not attempt to interfere with, compromise the system
              integrity or security, or decipher any transmissions to or from
              the servers running the App, Site, or Service;
            </li>
            <li>
              You will not take any action that imposes, or may impose at our
              sole discretion, an unreasonable or disproportionately large load
              on our infrastructure;
            </li>
            <li>
              You will not upload invalid data, viruses, worms or other software
              agents through the App, Site, or Service;
            </li>
            <li>
              You will not collect or harvest any personally identifiable
              information, including account names, from the App, Site, or
              Service;
            </li>
            <li>
              You will not access the App, Site or Service through any
              technology or means other than those provided or authorized by
              Sure;
            </li>
            <li>
              You agree not to stalk, harass, bully or harm another individual
              who uses our App, Site or Service;
            </li>
            <li>
              You agree not to impersonate any person or entity or misrepresent
              your affiliation with a person or entity;
            </li>
            <li>
              You agree to use our App only in a safe manner and in compliance
              with all laws, you explicitly agree that you will not use the App
              or Site for any criminal communications or for transmitting any
              child pornography;
            </li>
            <li>
              You agree that you will not hold Sure responsible for your use of
              our App or Site;
            </li>
            <li>
              You agree not to violate any requirements, procedures, policies or
              regulations of networks connected to Sure;
            </li>
            <li>
              You agree not to interfere with or disrupt the App, Site, or
              Service;
            </li>
            <li>You agree not to hack, spam or phish us or other users;</li>
            <li>You agree to provide truthful and accurate Content;</li>
            <li>
              You agree to not violate any law or regulation and you are
              responsible for such violations;
            </li>
            <li>
              You will not use our App, Site or Service to post any false,
              misleading, unlawful, defamatory, obscene, invasive, threatening,
              harassing, inflammatory, fraudulent Content;
            </li>
            <li>
              You agree not to cause, or aid in, the destruction, manipulation,
              removal, disabling, or impairment of any portion of our Site,
              including the de-indexing or de-caching of any portion of our Site
              from a thirty party’s website, such as by requesting its removal
              from a search engine;
            </li>
            <li>
              You will not upload any Content to our that includes any third
              party intellectual property unless you have permission from the
              owner to use it in the specific manner that you used it;
            </li>
          </ul>
          <p className={styles.paragraph}>
            If you are discovered to be undertaking any of the aforementioned
            actions your privileges to use our App, Site, or Services may at our
            discretion be terminated or suspended.
          </p>
          <h2 className={styles.subheadline}>Payment</h2>
          <p className={styles.paragraph}>
            You understand and agree that use of Sure’s Services may result in
            charges to you for insurance products or coverage you receive from
            third party insurance providers ("Insurance Partners"). Sure will
            facilitate your payment of fees, premiums, and/or taxes on behalf of
            the Insurance Partner, as such Insurance Partners limited payment
            collection agent. All charges shall be inclusive or applicable taxes
            as required by law. All charges are final and non-refundable.
          </p>
          <p className={styles.paragraph}>
            Payment of our Insurance Partners fees and premiums are due
            immediately and payment will be facilitated by Sure using the
            preferred payment method designated in your Sure Account, after
            which Sure will send you a receipt via email.
          </p>
          <p className={styles.paragraph}>
            Software and Site Availability
            <br />
            We do not guarantee that the App or Site will always be available,
            work, or be accessible at any particular time. Only users who are
            eligible to use our App may do so. We reserve the right to terminate
            access for anyone. We cannot guarantee that the App will work as
            advertised, or that it will give you the desired results.
          </p>
          <h2 className={styles.subheadline}>Taxes</h2>
          <p className={styles.paragraph}>
            You agree that you are responsible for all taxes and fees associated
            with your use of the App and Service. Although we may deduct nexus
            taxes or other taxes, you agree that if we do not, you will pay any
            associated taxes, levies, or fees.
          </p>
          <h2 className={styles.subheadline}>
            Compliance With All Laws and Regulations
          </h2>
          <p className={styles.paragraph}>
            Sure is not responsible for your violation of any laws while using
            our Site and Service. Users must comply with all local, state, or
            federal laws regarding your use of our Site and Service. Our App and
            Service are void where prohibited.
          </p>
          <h2 className={styles.subheadline}>Intellectual Property Rights</h2>
          <p className={styles.paragraph}>
            The design of the App and Site, along with Sure created text,
            templates, scripts, graphics, interactive features and the
            trademarks, service marks and logos contained therein ("Marks"), are
            owned by or licensed to Sure, subject to copyright and other
            intellectual property rights under United States and foreign laws
            and international conventions. Sure reserves all rights not
            expressly granted in and to the Service and the Site. You agree to
            not engage in the use, copying, or distribution anything contained
            within the Site or Service unless we have given express written
            permission.
          </p>
          <h2 className={styles.subheadline}>Representations and Warranties</h2>
          <p className={styles.paragraph}>
            OUR APP, SITE AND/OR SERVICE ARE OFFERED "AS-IS", INCLUDING ANY
            ERRORS, BUGS OR OTHER TECHNICAL ISSUES. YOU AGREE THAT WHILE USING
            OUR APP, SITE, OR SERVICE, YOUR RESULTS MAY VARY AND YOU MAY NOT
            ACHIEVE ANY DESIRED RESULTS. WE EXPRESSLY DISCLAIM ALL WARRANTIES
            EITHER EXPRESS OR IMPLIED. OUR SITE, SOFTWARE, OR SERVICE MAY NOT BE
            FIT FOR A PARTICULAR PURPOSE AND MAY NOT WORK OR BE APPLICABLE WHERE
            YOU RESIDE. WE MAKE NO REPRESENTATIONS OR WARRANTIES AS TO THE
            REASONABLE SKILL AND CARE INVESTED IN OUR SERVICE, SATISFACTORY
            QUALITY OF OUR SERVICE, MERCHANTABILITY OF OUR SERVICE OR THAT OUR
            SERVICE IS NON-INFRINGING. FURTHERMORE, WE DO NOT WARRANT THAT THE
            FUNCTIONS CONTAINED IN THE SITE OR SERVICE WILL MEET ANY
            REQUIREMENTS OR NEEDS YOU MAY HAVE, THAT THE SITE OR SERVICE WILL
            OPERATE ERROR FREE OR IN AN UNINTERRUPTED FASHION, THAT ANY DEFECTS
            OR ERRORS IN THE SITE OR SERVICE WILL BE CORRECTED, OR THAT THE SITE
            OR SERVICE IS COMPATIBLE WITH ANY PARTICULAR PLATFORM. SURE IS NOT
            OBLIGATED TO PROVIDE YOU ACCESS TO OUR SITE AND SERVICE. IN THE
            EVENT OF ANY PROBLEM WITH THE SITE OR SERVICE, YOU AGREE THAT YOUR
            SOLE REMEDY IS TO CEASE USING THE SITE OR SERVICE.
          </p>
          <h2 className={styles.subheadline}>Limitation of Liability</h2>
          <p className={styles.paragraph}>
            IN NO EVENT SHALL SURE ITS OFFICERS, DIRECTORS, EMPLOYEES, OR
            AGENTS, BE LIABLE TO YOU FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL, PUNITIVE, OR CONSEQUENTIAL DAMAGES WHATSOEVER RESULTING
            FROM (I) YOUR USE OR INABILITY TO USE THE APP, WEBSITE OR OUR
            SERVICES ERRORS, MISTAKES, OR INACCURACIES OF CONTENT, (II) ANY
            PERSONAL INJURY OR PROPERTY DAMAGE, OF ANY NATURE WHATSOEVER,
            RESULTING FROM YOUR ACCESS TO AND USE OF OUR SITE OR SERVICE, (III)
            ANY INTERRUPTION, MISINFORMATION, INCOMPLETE INFORMATION, OR
            CESSATION OF TRANSMISSION TO OR FROM OUR SOFTWARE TO YOU, (IV) ANY
            BUGS, VIRUSES, TROJAN HORSES, OR THE LIKE, WHICH MAY BE TRANSMITTED
            TO OR THROUGH OUR SITE BY ANY THIRD PARTY, (V) ANY FAILURE OF ANY
            THIRD PARTY INFORMATION LISTED ON OUR SITE AND SERVICE, INCLUDING
            ANY FAILURES OR DISRUPTIONS WHETHER INTENTIONAL OR UNINTENTIONAL OR
            (VI) ANY ERRORS OR OMISSIONS IN OUR SITE OR SERVICE FOR ANY LOSS OR
            DAMAGE OF ANY KIND INCURRED AS A RESULT OF YOUR USE OF OUR SITE OR
            SERVICE, WHETHER BASED ON WARRANTY, CONTRACT, TORT, OR ANY OTHER
            LEGAL THEORY, AND WHETHER OR NOT THE COMPANY IS ADVISED OF THE
            POSSIBILITY OF SUCH DAMAGES. THE FOREGOING LIMITATION OF LIABILITY
            SHALL APPLY TO THE FULLEST EXTENT PERMITTED BY LAW IN THE APPLICABLE
            JURISDICTION
          </p>
          <p className={styles.paragraph}>
            For Jurisdictions that do not allow us to limit our liability:
            Notwithstanding any provision of these Terms, if your jurisdiction
            has provisions specific to waiver or liability that conflict with
            the above then our liability is limited to the smallest extent
            possible by law. Specifically, in those jurisdictions not allowed,
            we do not disclaim liability for: (a) death or personal injury
            caused by its negligence or that of any of its officers, employees
            or agents; or (b) fraudulent misrepresentation; or (c) any liability
            which it is not lawful to exclude either now or in the future.
          </p>
          <p className={styles.paragraph}>
            IF YOU ARE A RESIDENT OF A JURISDICTION THAT REQUIRES A SPECIFIC
            STATEMENT REGARDING RELEASE THEN THE FOLLOWING APPLIES. FOR EXAMPLE,
            CALIFORNIA RESIDENTS MUST, AS A CONDITION OF THIS AGREEMENT, WAIVE
            THE APPLICABILITY OF CALIFORNIA CIVIL CODE SECTION 1542, WHICH
            STATES, "A GENERAL RELEASE DOES NOT EXTEND TO CLAIMS WHICH THE
            CREDITOR DOES NOT KNOW OR SUSPECT TO EXIST IN HIS OR HER FAVOR AT
            THE TIME OF EXECUTING THE RELEASE, WHICH IF KNOWN BY HIM OR HER MUST
            HAVE MATERIALLY AFFECTED HIS OR HER SETTLEMENT WITH THE DEBTOR." YOU
            HEREBY WAIVE THIS SECTION OF THE CALIFORNIA CIVIL CODE. YOU HEREBY
            WAIVE ANY SIMILAR PROVISION IN LAW, REGULATION, OR CODE THAT HAS THE
            SAME INTENT OR EFFECT AS THE AFOREMENTIONED RELEASE. YOUR ABILITY TO
            USE OUR SOFTWARE AND SERVICE IS CONTINGENT ON YOUR AGREEMENT WITH
            THIS AND ALL OTHER SECTIONS OF THIS AGREEMENT. YOU AGREE OUR TOTAL
            LIABILITY TO YOU IS NOT MORE THAN $100 U.S. DOLLARS OR THE TOTAL
            AMOUNT YOU SPENT WHILE USING OUR SITE, SOFTWARE, AND SERVICE WITHIN
            THE LAST SIX MONTHS, WHICHEVER IS GREATER.
          </p>
          <h2 className={styles.subheadline}>Indemnity</h2>
          <p className={styles.paragraph}>
            You agree to defend, indemnify and hold harmless Sure, its officers,
            directors, employees and agents, from and against any and all
            claims, damages, obligations, losses, liabilities, costs or debt,
            and expenses (including but not limited to attorney's fees) arising
            from:
          </p>
          <p className={styles.paragraph}>
            your use of and access to the Sure App, Site and/or Service;
            <br />
            your violation of any term of these Terms of Service;
            <br />
            your violation of any third party right, including without
            limitation any copyright, property, or privacy right; or
            <br />
            any claim that any of your Content caused damage to a third party.
            <br />
            This defense and indemnification obligation will survive this
            Agreement and your use of the Sure App, Site, or Service. You also
            agree that you have a duty to defend us against such claims and we
            may require you to pay for an attorney(s) of our choice in such
            cases. You agree that this indemnity extends to requiring you to pay
            for our reasonable attorneys’ fees, court costs, and disbursements.
            In the event of a claim such as one described in this paragraph, we
            may elect to settle with the party/parties making the claim and you
            shall be liable for the damages as though we had proceeded with a
            trial.
          </p>
          <h2 className={styles.subheadline}>COPPA Compliance</h2>
          <p className={styles.paragraph}>
            Sure and its Services may only be used by persons 18 years and
            older. If you are under 18 please stop using our App and our Site,
            and do not submit any information to us.
          </p>
          <h2 className={styles.subheadline}>Choice of Law</h2>
          <p className={styles.paragraph}>
            All matters relating to the App or Site, and these Terms of Service
            and any dispute or claim arising under or relating to the App, Site
            or these Terms of Service, shall be governed by and construed in
            accordance with the internal laws of the state of California, U.S.A.
            without giving effect to any choice of law provision of rule
            (whether of the state of New York or any other jurisdiction.)
          </p>
          <h2 className={styles.subheadline}>Form of Dispute</h2>
          <p className={styles.paragraph}>
            Any dispute relating in any way to your use of the App, Site, or
            Services, or your purchase of insurance through Sure shall be
            submitted to confidential arbitration in California, U.S.A, except
            that to the extent you have in any manner violated or threatened to
            violate our intellectual property rights, we may seek injunctive or
            other appropriate relief in any state or federal court having
            jurisdiction. You hereby consent to, and waive all defenses of lack
            of personal jurisdiction and forum non conveniens with respect to
            venue and jurisdiction in the state and federal courts of
            California. Arbitration under these Terms of Use shall be conducted
            pursuant to the Commercial Arbitration Rules then prevailing at the
            American Arbitration Association. The arbitrator's award shall be
            final and binding and may be entered as a judgment in any court of
            competent jurisdiction. To the fullest extent permitted by
            applicable law, no arbitration under these Terms of Use shall be
            joined to an arbitration involving any other party subject to these
            Terms of Use, whether through class action proceedings or otherwise.
            You agree that regardless of any statute or law to the contrary, any
            claim or cause of action arising out of, related to or connected
            with the use of the Sure App, Site, or Services or these Terms of
            Service must be filed within one (1) year after such claim or cause
            of action arose or be forever banned. No right or remedy of ours
            shall be exclusive of any other, whether at law or in equity,
            including without limitation damages injunctive relief, attorneys'
            fees and expenses. No instance of waiver by us of our rights or
            remedies under these Terms of Service shall imply any obligation to
            grant any similar, future or other waiver.
          </p>
          <h2 className={styles.subheadline}>Force Majeure</h2>
          <p className={styles.paragraph}>
            You agree that Sure is not responsible to you for anything that we
            may otherwise be responsible for, if it is the result of events
            beyond our control, including, but not limited to, acts of God, war,
            insurrection, riots, terrorism, crime, labor shortages (including
            lawful and unlawful strikes), embargoes, postal disruption,
            communication disruption, failure or shortage of infrastructure,
            shortage of materials, or any other event beyond our control.
          </p>
          <h2 className={styles.subheadline}>Severability</h2>
          <p className={styles.paragraph}>
            In the event that a provision of this Agreement is found to be
            unlawful, conflicting with another provision of the Agreement, or
            otherwise unenforceable, the Agreement will remain in force as
            though it had been entered into without that unenforceable provision
            being included in it. If two or more provisions of this Agreement
            are deemed to conflict with each other’s operation, Sure shall have
            the sole right to elect which provision remains in force.
          </p>
          <h2 className={styles.subheadline}>Non-Waiver</h2>
          <p className={styles.paragraph}>
            We reserve all rights permitted to us under this Agreement as well
            as under the provisions of any applicable law. Our non-enforcement
            of any particular provision or provisions of this Agreement or the
            any applicable law should not be construed as our waiver of the
            right to enforce that same provision under the same or different
            circumstances at any time in the future.
          </p>
          <h2 className={styles.subheadline}>Termination of Service</h2>
          <p className={styles.paragraph}>
            We may terminate or suspend your Sure Account, or our App, Site,
            and/or Service without notice, though we will strive to provide a
            timely explanation in most cases. Please be aware that if we
            terminate service, you may be entitled to a refund if applicable.
            All provisions of this Agreement which by their nature should
            survive termination shall survive termination, including, without
            limitation, ownership provisions, warranty disclaimers, indemnity
            and limitations of liability.
          </p>
          <h2 className={styles.subheadline}>Assignment</h2>
          <p className={styles.paragraph}>
            You may not assign your rights and/or obligations under this
            Agreement to any other party without our prior written consent. We
            may assign our rights and/or obligations under this Agreement to any
            other party at our discretion.
          </p>
          <h2 className={styles.subheadline}>Amendments</h2>
          <p className={styles.paragraph}>
            We may amend this Agreement from time to time. When we amend this
            Agreement, we will update this page and indicate the date that it
            was last modified, make an announcement on our homepage or we may
            email you. You may refuse to agree to the amendments, but if you do,
            you must immediately cease using our Site and our Service.
          </p>
          <h2 className={styles.subheadline}>Electronic Communications</h2>
          <p className={styles.paragraph}>
            The communications between you and Sure use electronic means,
            whether you use our App, or visit the Site, or send Sure e-mails,
            social media, or other messages, or whether Sure posts notices on
            the App, Site, or Service or communications with you via e-mail, or
            social media. For contractual purposes, you (1) consent to receive
            communications from Sure in an electronic form; (2) agree that all
            terms, conditions, agreements, notices, disclosures, and other
            communications that Sure provides to you electronically satisfy any
            legal requirement that such communications would satisfy if it were
            to be in writing. The foregoing does not affect your statutory
            rights.
          </p>
          <h2 className={styles.subheadline}>California Users and Residents</h2>
          <p className={styles.paragraph}>
            Pursuant to California Civil Code Section 1789.3, any questions
            about pricing, complaints, or inquiries about Sure must be addressed
            to our agent for notice and sent via certified mail to: Sure, Inc.,
            1460 Broadway, New York, NY 10036. Lastly, California users are also
            entitled to the following specific consumer rights notice: The
            Complaint Assistance Unit of the Division of Consumer Services of
            the California Department of Consumer Affairs may be contacted in
            writing at 1625 North Market Blvd., Sacramento, CA 95834, or by
            telephone at (916) 445-1254 or (800) 952-5210.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsOfUse;
